import React from 'react';
import { inject, observer } from 'mobx-react';
import {
  Input, Row, Col, Table, Popconfirm, Radio, Button, Icon,
} from 'antd';
import { toJS } from 'mobx';
import AppDatasBody from '../util/AppDatasBody';

const RadioGroup = Radio.Group;
const store = ['authorityStore', 'initStore'];

@inject(...store)
@observer
class Authority extends React.Component {

  async componentDidMount() {
    const { authorityStore } = this.props;
    authorityStore.getAuth();
  }

  render() {
    const { location, authorityStore } = this.props;
    const { searchValue: { userName, auth }
      , setSearchValue, addAuth, setPage, getAuth, authDatas
      , loading, page, resetSearchValue } = authorityStore;
    const columns = [
      { title: '编号', dataIndex: 'ecId', key: 'ecId' },
      { title: '姓名', dataIndex: 'name', key: 'name' },
      { title: '部门', dataIndex: 'department', key: 'department' },
      {
        title: '操作', dataIndex: 'operate', key: 'operate',
        render: (text, record) => {
          return record.auth === "0" ? (<Popconfirm title='确定添加权限吗？' onConfirm={() => { addAuth(record,'1') }}>
            <span className='list-table-btn'>添加权限</span>
        </Popconfirm>) : (<Popconfirm title='确定取消权限吗？' onConfirm={() => { addAuth(record,'0') }}>
            <span className='list-table-btn'>取消权限</span>
          </Popconfirm>)
        }
      }
    ];
    const hasAuthOptions = [
      { label: '全部', value: '-1' },
      { label: '未添加', value: '0' },
      { label: '已添加', value: '2' },
    ]
    const me = !!localStorage.me ? JSON.parse(localStorage.me) : { role: "" };
    const isAdmin = me.role === "admin";
    return (
      <div className='price setting'>
        <AppDatasBody location={location}>
          {
            isAdmin ? (<div>
              <Row className="cs-search-mylist">
                <Col span={8}>
                  <Col span={8} className='price-label'> <label>姓名：</label></Col>
                  <Col span={14}>
                    <Input placeholder='请输入姓名' value={userName}
                      onChange={e => setSearchValue({ userName: e.target.value })}/>
                  </Col>
                </Col>
                <Col span={8}>
                  <Col span={8} className='price-label'> <label>修改权限：</label></Col>
                  <Col span={16} className='price-content'>
                    <RadioGroup options={hasAuthOptions} value={auth}
                      onChange={e => setSearchValue({ auth: e.target.value })} />
                  </Col>
                </Col>
                <Col span={8}>
                  <Col span={19} offset={5}>
                    <Button type="primary"
                      style={{ marginRight: 10 }}
                      onClick={getAuth}>搜索</Button>
                    <Button type="ghost"
                      style={{ marginRight: 10 }}
                      onClick={() => resetSearchValue()}>重置</Button>
                  </Col>
                </Col>
              </Row>
              <Table columns={columns}
                dataSource={toJS(authDatas)}
                loading={loading}
                className='list-table'
                pagination={{
                  ...page,
                  showSizeChanger: true,
                  showQuickJumper: true,
                  showTotal: (total) => `共${total}条`,
                  onChange: (pageNum, pageSize) => {
                    setPage({ current: pageNum, pageSize: pageSize });
                    getAuth();
                  },
                  onShowSizeChange: (current, size) => {
                    setPage({ current: 1, pageSize: size });
                    getAuth();
                  }
                }}
              />
            </div>) : (
              <div className='cs-search-mylist-noRight'>
                <Icon type="lock" />
                <div>对不起，您暂时没有权限！</div>
                </div>
            )
          }
         
        </AppDatasBody>
      </div>
    );
  }
}
export default Authority;


// WEBPACK FOOTER //
// ./src/components/setting/Authority.js